import { useMutation } from '@tanstack/react-query';
import z from 'zod';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { CURRENCY } from 'src/types';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/:payStationId/levels/change-availability/`;

export type PayStationCashLevelsFormSchemaValues = z.infer<typeof payStationCashLevelsFormSchema>;
export const payStationCashLevelsFormSchema = z.object({
    coins: z.array(
        z.object({
            currency: z.enum(CURRENCY),
            value: z.string(),
            count: z.int().min(0),
        }),
    ),
    banknotes: z.array(
        z.object({
            currency: z.enum(CURRENCY),
            value: z.string(),
            count: z.int().min(0),
        }),
    ),
});

type MutationFnType = typeof mutationFn;

interface DTO extends PayStationCashLevelsFormSchemaValues {
    payStationId: string;
    parkingId: string;
}

const mutationFn = ({ payStationId, parkingId, ...data }: DTO): Promise<Record<string, any>> => {
    return axios.post(formatResourcePath(RESOURCE, { payStationId, parkingId }), { ...data });
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useChangeCoinBanknoteAvailability };
